import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "watch",
  "description": "API reference for the `watch` command"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Re-run tasks in your repository, based on code changes."
  }, {
    "heading": "",
    "content": "turbo watch is dependency-aware, meaning tasks will re-run in the order configured in turbo.json."
  }, {
    "heading": "",
    "content": "If no tasks are provided, turbo will display what tasks are available for the packages in the repository."
  }, {
    "heading": "using-turbo-watch-with-persistent-tasks",
    "content": "Persistent tasks are marked with \"persistent\": true, meaning they won't exit. Because of this, they cannot be depended on in your task graph."
  }, {
    "heading": "using-turbo-watch-with-persistent-tasks",
    "content": "This means that persistent tasks will be ignored when using turbo watch, working the same way they do with turbo run, allowing persistent and non-persistent tasks to be run at the same time."
  }, {
    "heading": "dependency-aware-persistent-tasks",
    "content": "When your script has a built-in watcher (like next dev) capable of detecting changes in dependencies, you don't need to use turbo watch. Instead, use your script's built-in watcher and mark the task as long-running using \"persistent\": true."
  }, {
    "heading": "persistent-tasks-without-dependency-awareness",
    "content": "Some tools aren't monorepo-friendly, and do not hot-reload modules in dependencies. In those cases, you should\nmark the task as interruptible: true to have turbo watch\nrestart the task when relevant changes are detected."
  }, {
    "heading": "caching",
    "content": "Caching tasks with Watch Mode is currently experimental, under the --experimental-write-cache flag."
  }, {
    "heading": "task-outputs",
    "content": "If you have tasks that write to files checked into source control, there is a possibility that Watch Mode will run in an infinite loop. This is because Watch Mode watches your\nfiles for changes and will re-run tasks in packages that have changed. If a task creates a change, then that will trigger the task again."
  }, {
    "heading": "task-outputs",
    "content": "Watch Mode has some logic to prevent this from happening using file hashes, but it isn't foolproof. To avoid this issue, we recommend removing any task outputs from git."
  }],
  "headings": [{
    "id": "using-turbo-watch-with-persistent-tasks",
    "content": "Using turbo watch with persistent tasks"
  }, {
    "id": "dependency-aware-persistent-tasks",
    "content": "Dependency-aware persistent tasks"
  }, {
    "id": "persistent-tasks-without-dependency-awareness",
    "content": "Persistent tasks without dependency awareness"
  }, {
    "id": "limitations",
    "content": "Limitations"
  }, {
    "id": "caching",
    "content": "Caching"
  }, {
    "id": "task-outputs",
    "content": "Task outputs"
  }]
};
export const toc = [{
  depth: 2,
  url: "#using-turbo-watch-with-persistent-tasks",
  title: _jsxs(_Fragment, {
    children: ["Using ", _jsx("code", {
      children: "turbo watch"
    }), " with persistent tasks"]
  })
}, {
  depth: 3,
  url: "#dependency-aware-persistent-tasks",
  title: _jsx(_Fragment, {
    children: "Dependency-aware persistent tasks"
  })
}, {
  depth: 3,
  url: "#persistent-tasks-without-dependency-awareness",
  title: _jsx(_Fragment, {
    children: "Persistent tasks without dependency awareness"
  })
}, {
  depth: 2,
  url: "#limitations",
  title: _jsx(_Fragment, {
    children: "Limitations"
  })
}, {
  depth: 3,
  url: "#caching",
  title: _jsx(_Fragment, {
    children: "Caching"
  })
}, {
  depth: 3,
  url: "#task-outputs",
  title: _jsx(_Fragment, {
    children: "Task outputs"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    p: "p",
    pre: "pre",
    span: "span",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "Re-run tasks in your repository, based on code changes."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " watch"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " [tasks]"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo watch"
      }), " is dependency-aware, meaning tasks will re-run in the order ", _jsxs(_components.a, {
        href: "/docs/reference/configuration",
        children: ["configured in ", _jsx(_components.code, {
          children: "turbo.json"
        })]
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["If no tasks are provided, ", _jsx(_components.code, {
        children: "turbo"
      }), " will display what tasks are available for the packages in the repository."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " watch"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.h2, {
      id: "using-turbo-watch-with-persistent-tasks",
      children: ["Using ", _jsx(_components.code, {
        children: "turbo watch"
      }), " with persistent tasks"]
    }), "\n", _jsxs(_components.p, {
      children: ["Persistent tasks are marked with ", _jsx(_components.a, {
        href: "/docs/reference/configuration#persistent",
        children: _jsx(_components.code, {
          children: "\"persistent\": true"
        })
      }), ", meaning they won't exit. Because of this, they cannot be depended on in your task graph."]
    }), "\n", _jsxs(_components.p, {
      children: ["This means that persistent tasks will be ignored when using ", _jsx(_components.code, {
        children: "turbo watch"
      }), ", working the same way they do with ", _jsx(_components.a, {
        href: "/docs/reference/run",
        children: _jsx(_components.code, {
          children: "turbo run"
        })
      }), ", allowing persistent and non-persistent tasks to be run at the same time."]
    }), "\n", _jsx(_components.h3, {
      id: "dependency-aware-persistent-tasks",
      children: "Dependency-aware persistent tasks"
    }), "\n", _jsxs(_components.p, {
      children: ["When your script has a built-in watcher (like ", _jsx(_components.code, {
        children: "next dev"
      }), ") capable of detecting changes in dependencies, you don't need to use ", _jsx(_components.code, {
        children: "turbo watch"
      }), ". Instead, use your script's built-in watcher and mark the task as long-running using ", _jsx(_components.a, {
        href: "/docs/reference/configuration#persistent",
        children: _jsx(_components.code, {
          children: "\"persistent\": true"
        })
      }), "."]
    }), "\n", _jsx(_components.h3, {
      id: "persistent-tasks-without-dependency-awareness",
      children: "Persistent tasks without dependency awareness"
    }), "\n", _jsxs(_components.p, {
      children: ["Some tools aren't monorepo-friendly, and do not hot-reload modules in dependencies. In those cases, you should\nmark the task as ", _jsx(_components.a, {
        href: "/docs/reference/configuration#interruptible",
        children: _jsx(_components.code, {
          children: "interruptible: true"
        })
      }), " to have ", _jsx(_components.code, {
        children: "turbo watch"
      }), "\nrestart the task when relevant changes are detected."]
    }), "\n", _jsx(_components.h2, {
      id: "limitations",
      children: "Limitations"
    }), "\n", _jsx(_components.h3, {
      id: "caching",
      children: "Caching"
    }), "\n", _jsxs(_components.p, {
      children: ["Caching tasks with Watch Mode is currently experimental, under the ", _jsx(_components.code, {
        children: "--experimental-write-cache"
      }), " flag."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " watch"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " your-tasks"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --experimental-write-cache"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "task-outputs",
      children: "Task outputs"
    }), "\n", _jsx(_components.p, {
      children: "If you have tasks that write to files checked into source control, there is a possibility that Watch Mode will run in an infinite loop. This is because Watch Mode watches your\nfiles for changes and will re-run tasks in packages that have changed. If a task creates a change, then that will trigger the task again."
    }), "\n", _jsx(_components.p, {
      children: "Watch Mode has some logic to prevent this from happening using file hashes, but it isn't foolproof. To avoid this issue, we recommend removing any task outputs from git."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
